import { AloftPrice, isUndefined } from '@aloft/toolkit-shared';

import { ValueFormatter } from '../../types.js';

export const adjustment: ValueFormatter = (adjustment: AloftPrice | undefined) => {
  if (isUndefined(adjustment)) {
    return { str: [''] };
  }

  if (!AloftPrice.isAloftPrice(adjustment)) {
    throw Error(`Invalid price: ${JSON.stringify(adjustment)}`);
  }

  const str = adjustment.toString(true);
  if (AloftPrice.zero.equals(adjustment)) {
    return { str: [str] };
  }

  const isPositive = adjustment.gt(AloftPrice.zero);

  return {
    str: [`${isPositive ? '+' : ''}${str}`],
    color: isPositive ? 'success' : 'alertError',
  };
};
